// extracted by mini-css-extract-plugin
export default {"row":"planogram-storage_row__YZPgo","placeHolderShimmer":"planogram-storage_placeHolderShimmer__ezhY9"};